{
  "pageTitle": "Reservations",
  "status": {
    "SOFT_RESERVATION": "Soft",
    "HARD_RESERVATION": "Confirmed",
    "SOLD": "Sold",
    "OPTION": "Option"
  },
  "columns": {
    "status": "Status",
    "mediaUnit": "Media unit",
    "dateFrom": "From",
    "dateTo": "To",
    "holder": "Holder",
    "offer": "Offer",
    "source": "Source",
    "queued": "Queue",
    "queuedTooltip": "Number of people waiting in the queue behind this reservation",
    "deadline": "Expires",
    "deadlineTooltip": "Reservation expiry deadline",
    "actions": "Actions"
  },
  "deadline": {
    "neverExpires": "Never expires",
    "noDeadlineSet": "No deadline set",
    "expiredMarker": "Expired — awaiting release"
  },
  "source": {
    "reservation_action": "Reservation",
    "manual_admin": "Manual (admin)",
    "xlsx_import": "XLSX import",
    "email_reply": "Email reply",
    "provider_override": "Supplier change",
    "ttl_expiry": "TTL expiry",
    "auto_promotion": "Automatic queue promotion",
    "auto_extension": "Automatic extension",
    "offer_version_locked": "Locked by offer version"
  },
  "auditActions": {
    "reservation": {
      "created": "Reservation created",
      "cancelled": "Reservation cancelled",
      "upgrade_hard": "Reservation confirmed",
      "close_sale": "Marked as sold",
      "override": "Status changed manually",
      "dates_updated": "Dates changed",
      "auto_extension": "Automatic option extension",
      "queue_joined": "Joined the queue",
      "queue_left": "Left the queue",
      "queue_removed": "Removed from queue",
      "queue_promoted": "Taken over from the queue",
      "force_release": "Force-released",
      "ttl_expiry_release": "Released after deadline (TTL) expiry",
      "expiry_deadline_updated": "Expiry deadline changed"
    }
  },
  "sortFields": {
    "status": "Status",
    "date_from": "From",
    "date_to": "To",
    "created_at": "Created at"
  },
  "actions": {
    "openUnit": "Open media unit",
    "openOffer": "Open offer",
    "upgradeHard": "Confirm reservation",
    "closeSale": "Close sale",
    "editDates": "Edit dates",
    "cancel": "Cancel reservation",
    "forceRelease": "Force release",
    "forceReleaseConfirmBody": "This will release the hold belonging to: {{holder}}. Continue?",
    "forceReleaseConfirmUnknownHolder": "another user",
    "releaseModeChoice": {
      "title": "What would you like to release?",
      "wholeLabel": "The entire reservation period",
      "selectedLabel": "Only the selected days"
    },
    "overrideStatus": "Manually change status",
    "blockAvailability": "Block availability",
    "openInPanel": "Open in reservations panel",
    "extendExpiry": "Edit expiry deadline"
  },
  "labels": {
    "noOffer": "—",
    "totalCount": "{{count}} reservations",
    "page": "Page {{page}} of {{total}}",
    "prevPage": "Previous",
    "nextPage": "Next",
    "sort": "Sort: {{field}} {{dir}}"
  },
  "filters": {
    "status": "Status",
    "offerId": "Offer",
    "clientId": "Client",
    "salespersonId": "Salesperson",
    "source": "Source",
    "dateFrom": "Date from",
    "dateTo": "Date to",
    "clearAll": "Clear filters",
    "addFilter": "Add filter",
    "applyLabel": "Apply",
    "searchLabel": "Search...",
    "noOptions": "No options",
    "myReservations": "My reservations"
  },
  "dialogs": {
    "upgradeHardTitle": "Confirm reservation",
    "upgradeHardBody": "Are you sure you want to confirm this reservation?",
    "closeSaleTitle": "Close sale",
    "closeSaleBody": "Are you sure you want to mark this reservation as sold?",
    "forceReleaseTitle": "Force release",
    "forceReleaseBody": "Are you sure you want to force-release this reservation?",
    "cancelConfirmBody": "Are you sure you want to cancel this reservation?",
    "confirmLabel": "Confirm",
    "cancelBtnLabel": "Cancel",
    "cancelTitle": "Cancel reservation",
    "cancelConfirmLabel": "Cancel reservation",
    "cancelWillBeFreeLabel": "The media unit will become free:",
    "editDatesTitle": "Edit dates",
    "dateRangeLabel": "Date range",
    "displacementWarningLabel": "Changing dates may require displacing queued reservations.",
    "forceCheckboxLabel": "Force displacement (admin)",
    "saveLabel": "Save",
    "overrideStatusTitle": "Manually change status",
    "targetStatusLabel": "New status",
    "reasonLabel": "Reason",
    "reasonPlaceholder": "Enter the reason for the status change...",
    "reasonRequiredLabel": "A reason is required.",
    "auditNoteLabel": "The change will be recorded in the event history.",
    "overrideConfirmLabel": "Change status",
    "ttlExpiresAtLabel": "Reservation deadline (TTL)",
    "ttlExpiresAtHint": "Optional: manually set the expiry date for this temporary reservation.",
    "ttlExpiresAtPlaceholder": "Select date",
    "errorConflict": "Reservation conflict — the change cannot be made.",
    "errorDisplacement": "This change requires displacement — check the 'Force' option to continue.",
    "errorStale": "The data is out of date. Refresh the page and try again.",
    "extendExpiryTitle": "Edit expiry deadline",
    "extendExpiryDescription": "You are changing the reservation's expiry deadline.",
    "extendExpiryCurrentLabel": "Current reservation expiry deadline",
    "extendExpiryNewLabel": "New reservation expiry deadline",
    "extendExpiryDatePlaceholder": "Select date",
    "extendExpiryReasonLabel": "Reason for the change",
    "extendExpiryReasonPlaceholder": "Describe the reason for the deadline change...",
    "extendExpiryReasonRequiredLabel": "A reason is required.",
    "extendExpirySaveLabel": "Save change"
  },
  "cancelBody": "Are you sure you want to cancel the reservation for media unit {{mediaUnitName}} for the period {{dateFrom}} – {{dateTo}}?",
  "unitTab": {
    "emptyState": "No reservations for this media unit",
    "emptyDescription": "This media unit has no active reservations.",
    "blockForMaintenance": "Block availability",
    "auditTimelineTitle": "Full event history",
    "auditTimelineShow": "Show",
    "auditTimelineHide": "Hide",
    "auditTimelineEmpty": "No events",
    "system": "system",
    "expandDetails": "Show details",
    "collapseDetails": "Hide details",
    "queueSectionTitle": "Waiting queue",
    "queueSectionSubtitle": "Ordered by request time",
    "queuePositionLabel": "Position {{position}} in queue",
    "queueSpansMultiple": "Also waiting on another period",
    "queueOwnBadge": "You",
    "queueSubmittedBy": "Submitted by:",
    "queueRemoveLabel": "Remove from queue",
    "queuePromoteLabel": "Transfer reservation",
    "expiryDeadlineAudit": {
      "title": "Reservation expiry deadline change",
      "actorLabel": "Changed by:",
      "previousLabel": "Previous deadline:",
      "newLabel": "New deadline:",
      "reasonLabel": "Reason:"
    }
  },
  "tabs": {
    "overview": "Overview",
    "reservations": "Reservations"
  },
  "waitlist": {
    "joinBtn": "Join queue",
    "inQueueLabel": "You are #{{position}} in the queue",
    "leaveBtn": "Leave queue",
    "sectionTitle": "{{count}} in queue",
    "leaveConfirmTitle": "Leave queue",
    "leaveConfirmBody": "Are you sure you want to leave the queue?",
    "leaveConfirmBtn": "Yes, leave",
    "adminRemoveTitle": "Remove from queue",
    "adminRemoveBody": "Are you sure you want to remove this person from the queue?",
    "adminRemoveBtn": "Yes, remove",
    "adminDisplaceTitle": "Take over reservation",
    "adminDisplaceBody": "Are you sure you want to force-release the active reservation and install the selected waiting person?",
    "adminDisplaceBtn": "Yes, take over",
    "addAnotherClientLabel": "Add an entry for another client",
    "newEntryTitle": "New entry",
    "cancelLabel": "Cancel",
    "clientLabel": "Client *",
    "brandLabel": "Brand",
    "offerLabel": "Offer (optional)",
    "clientPlaceholder": "Select a client",
    "brandPlaceholder": "Select a brand",
    "offerPlaceholder": "Select an offer",
    "clientSearchPlaceholder": "Search clients",
    "brandSearchPlaceholder": "Search brands",
    "offerSearchPlaceholder": "Search offers",
    "brandRequiredLabel": "Select a brand to join the queue.",
    "noBrandsLabel": "This client has no configured brands. Select another client.",
    "ownEntriesTitle": "Your queue entries",
    "changeIdentityLabel": "Change",
    "expiryLabel": "Expiry date",
    "expiryHint": "The system suggests an expiry date — you can change it using the calendar."
  },
  "queueOverview": {
    "hasQueueLabel": "Queue only",
    "holderColumnLabel": "Salesperson / Holder",
    "offerColumnLabel": "Client / Offer",
    "holderInlineLabel": "Holder",
    "salespersonLabel": "Salesperson:",
    "joinedAtLabel": "Joined:",
    "promotionEtaLabel": "Expected promotion:",
    "brandLabel": "Brand:",
    "openFullQueueLabel": "Open full queue"
  },
  "queuePromoteDialog": {
    "title": "Transfer this slot to the waiting person?",
    "subtitle": "{{mediaUnitName}} · window {{dateFrom}} – {{dateTo}}",
    "currentCardTitle": "Current reservation — will be removed",
    "nextCardTitle": "New reservation — queue position {{position}}",
    "holderLabel": "Holder",
    "clientLabel": "Client",
    "offerLabel": "Offer",
    "statusLabel": "Status",
    "noClientLabel": "None",
    "noOfferLabel": "None",
    "newStatusLabel": "Soft (new)",
    "consequencesTitle": "Consequences of this action",
    "consequenceForceReleased": "The current reservation (holder: {{holderUserName}}) will be permanently deleted (force release).",
    "consequenceNewReservation": "{{holderUserName}} will receive a new soft reservation starting {{dateFrom}}, with a new TTL deadline.",
    "consequenceNotified": "Holder {{holderUserName}} will be notified in-app about this change.",
    "consequenceQueuePositionsKept": "Other waiting entries keep their position in the queue.",
    "consequenceAudited": "This action will be recorded in the event history as a force release and slot transfer.",
    "cancelLabel": "Cancel",
    "confirmLabel": "Yes, transfer the slot"
  },
  "availabilityWindow": {
    "dialogTitle": "Block availability",
    "dialogBodyIntro": "Set an availability period for this media unit, independent of client reservations.",
    "dateRangeLabel": "Availability period",
    "dateRangePlaceholder": "Select date range…",
    "stateLabel": "State",
    "statePlaceholder": "Select state...",
    "state": {
      "FREE": "Free",
      "UNAVAILABLE": "Unavailable"
    },
    "saveLabel": "Save",
    "listTitle": "Availability windows",
    "emptyLabel": "No availability windows for this media unit.",
    "truncatedNotice": "Showing {{shown}} of {{total}}"
  },
  "toasts": {
    "availabilityWindowBlocked": "Cannot save the change – the selected date is blocked by a media unit unavailability window.",
    "availabilityWindowBlockedOnCreate": "Cannot create the reservation – the selected date is blocked by a media unit unavailability window.",
    "reservationOverlapsWindow": "Cannot block availability – there is an active media unit reservation in this period.",
    "batchReserveConflict": "Failed to reserve {{count}} dates — they are already taken by another reservation.",
    "batchReserveConflictStaleState": "Failed to reserve {{count}} dates — their state changed in the meantime. Refresh and try again.",
    "batchReserveConflictNotFound": "Failed to reserve {{count}} dates — the media unit or period does not exist.",
    "batchReserveConflictForbidden": "Failed to reserve {{count}} dates — no permission.",
    "batchReserveConflictValidationError": "Failed to reserve {{count}} dates — the reservation data is invalid.",
    "batchReserveConflictMinWindowViolation": "Failed to reserve {{count}} dates — the selected period is shorter than the minimum required for this media type.",
    "batchReserveConflictMinWindowViolationExact_one": "The minimum reservation period for this media type is {{minWindowDays}} day (you selected {{selectedDays}}).",
    "batchReserveConflictMinWindowViolationExact_other": "The minimum reservation period for this media type is {{minWindowDays}} days (you selected {{selectedDays}}).",
    "batchReserveConflictGeneric": "Failed to reserve {{count}} dates.",
    "batchReleaseSkipped": "Failed to release {{count}} reservations — they were already sold, previously released, or do not exist."
  }
}
